export const isFullStatic = false
export const staticPath = "/usr/share/nginx/html/bekaert.cn/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"